import type { FC } from 'react';
import { useRoutes } from 'react-router-dom';
import { CssBaseline, ThemeProvider } from '@mui/material';
import './i18n';
import { Toaster } from 'react-hot-toast';
import GlobalStyles from './components/GlobalStyles';
import RTL from './components/RTL';
import SplashScreen from './components/SplashScreen';
// import { gtmConfig } from './config';
import useAuth from './hooks/useAuth';
import useScrollReset from './hooks/useScrollReset';
import useSettings from './hooks/useSettings';
// import gtm from './lib/gtm';
import routes from './routes';
import { createTheme } from './theme';
import useConsoleOverride from './hooks/useConsoleOverride';

const App: FC = () => {
  const content = useRoutes(routes);
  const { settings } = useSettings();
  const auth = useAuth();
  useScrollReset();

  if (process.env.NODE_ENV !== 'development') {
    useConsoleOverride();
  }

  // useEffect(() => {
  //  gtm.initialize(gtmConfig);
  // }, []);

  const theme = createTheme({
    direction: settings.direction,
    responsiveFontSizes: settings.responsiveFontSizes,
    roundedCorners: settings.roundedCorners,
    theme: settings.theme
  });

  return (
    <ThemeProvider theme={theme}>
      <RTL direction={settings.direction}>
        <CssBaseline />
        <GlobalStyles />
        {auth.isInitialized ? content : <SplashScreen />}
      </RTL>
      <Toaster
        toastOptions={{
          style: {
            // Optional: Hintergrund und Textfarbe anpassen
            background: theme.palette.background.paper,
            color: theme.palette.text.primary,
          }
        }}
      />
    </ThemeProvider>
  );
};

export default App;
